import { Link } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";

// Plain-language data-handling statement shown under the pricing cards.
export const SecurityBlock = () => (
  <div data-testid="security-block" className="lg:col-span-12 rounded-2xl border border-[#2A2A2A] bg-[#121212] p-6 md:p-8 grid md:grid-cols-12 gap-6 items-start">
    <ShieldCheck size={32} className="text-[#00FF9D] md:col-span-1" />
    <div className="md:col-span-8">
      <h3 className="font-display text-xl">Your financial data, handled plainly</h3>
      <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">
        We read your Stripe, bank and QuickBooks data to build your runway model. We never move money, charge your customers, change your books or sell your data.
        Bank access is read-only, connection keys are stored encrypted, and you can disconnect or delete everything at any time.
      </p>
    </div>
    <Link to="/security" data-testid="pricing-security-link" className="md:col-span-3 md:justify-self-end text-sm text-[#00FF9D] underline underline-offset-4 hover:text-white transition-colors">
      How we handle your data
    </Link>
  </div>
);
